import { useView } from '@10000/react'
import { Body, Box, Button, Dialog, H4 } from '../../widgets'
import './ConfirmExit.scss'

export const ConfirmExit = ({ open, onConfirm, onCancel }) => {
  const { stage, teamAverages } = useView('squiz')
  const started = teamAverages.filter(x => x !== null).length > 0
  const exitToDashboard = stage === 'analytics'

  return (
    <Dialog open={open} onClose={onCancel} showControls={false} mobileDrawer={false} mobileBackground="white">
      <Box column gap={16}>
        <H4 fullWidth align="left" className="exit-text">
          {exitToDashboard ? 'Exit Squiz' : 'Ending Squiz'}
        </H4>
        <Body className="exit-text">
          {exitToDashboard
            ? <>Exiting the squiz will stop broadcasting analytics to participants and the main display.<br/>Are you sure you wish to do this?</>
            : <>You are about to <Body bold>end a Squiz early</Body> and will not be able to continue later.</>
          }
        </Body>
        <Box fullWidth className="exit-buttons">
          {!exitToDashboard && started && <Button fullWidth onClick={() => onConfirm(true)}>Take me to results</Button>}
          <Button fullWidth onClick={() => onConfirm(false)}>Exit to dashboard</Button>
          {exitToDashboard && <Button fullWidth onClick={onCancel} light>Cancel</Button>}
        </Box>
      </Box>
    </Dialog>
  )
}